import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import {verificationMailSent } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const sentMailService = createAsyncThunk(
    'fetchPreAuthFAF', verificationMailSent
)

const initialState = {
    loader: false
}

const sentMailSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetSentMail: (state) => {
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(sentMailService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(sentMailService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(sentMailService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetSentMail } = sentMailSlice.actions

export default sentMailSlice.reducer